import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import {
  saveAndNextInsection,
  submitTestApi,
} from "../../../services/saveAndNext";

const IitSectionTimer2 = (props) => {
  const [showTimer, setShowTimer] = useState("00:00:00");
  const intervalRef = useRef(null);
  const sectionIndexRef = useRef(0); // ✅ Keeps track of current section index

  const formatTime = (seconds) => {
    return (
      Math.floor(seconds / 3600) +
      " : " +
      ("0" + (Math.floor(seconds / 60) % 60)).slice(-2) +
      " : " +
      ("0" + (seconds % 60)).slice(-2)
    );
  };

  const startSectionTimer = (initialTime) => {
    let timeLeft = initialTime;

    setShowTimer(formatTime(timeLeft));

    intervalRef.current = setInterval(() => {
      timeLeft -= 1;
      setShowTimer(formatTime(timeLeft));
      sessionStorage.setItem("SessionleftTimeToSubmit", timeLeft);

      if (timeLeft <= 1) {
        clearInterval(intervalRef.current);
      
        const nextIndex = sectionIndexRef.current + 1;
      
        // console.log("⏳ Current Section Index:", sectionIndexRef.current);
        // console.log("📍 Next Index:", nextIndex);
        // console.log("📚 allSection:", props.allSection);
        // console.log("➡️ Next Section ID:", props.allSection[nextIndex]);
      
        if (nextIndex < props.allSection.length) {
          sectionIndexRef.current = nextIndex;
          const nextSectionId = props.allSection[nextIndex];
      
          setTimeout(() => {
            changeSection(nextSectionId);
          }, 1000);
        } else {
          // console.log("✅ No more sections, submitting test");
          submitTestApi(props);
        }
      }
      
    }, 1000);
  };

  const changeSection = async (sectionId) => {
    // console.log("🔄 Changing to section:", sectionId);
  
    if (intervalRef.current) clearInterval(intervalRef.current);
  
    props.dispatch({ type: "SELECTED_SUBJECT", selectedSection: sectionId });
  
    // console.log("📄 All subjects_data:", props.state.subjects_data);
  
    const timeObj = props.state.subjects_data.find(
      (el) => `${el.subject_id}#${el.section_id}` === sectionId
    );
  
    // console.log("🧠 Matched section object:", timeObj);
  
    const sectionTimeSec = parseInt(timeObj?.section_time || "0") * 60;
    // console.log("🕒 Time for section (sec):", sectionTimeSec);
  
    if (sectionTimeSec > 0) {
      startSectionTimer(sectionTimeSec);
      saveAndNextInsection(sectionTimeSec);
    } else {
      // console.log("⛔ No time left or not found, submitting test");
      submitTestApi(props);
    }
  };
  
  

  useEffect(() => {
    if (props.allSection.length > 0) {
      const initialSectionId =
        props?.state?.current_section_id || props.allSection[0];
  
      // console.log("🚀 Starting with sectionId:", initialSectionId);
      // console.log("📚 All section IDs:", props.allSection);
  
      const initialIndex = props.allSection.findIndex(
        (secId) => secId === initialSectionId
      );
      sectionIndexRef.current = initialIndex !== -1 ? initialIndex : 0;
  
      changeSection(initialSectionId);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [props.allSection]);
  
  return (
    <div className="timerDiv">
      <span className="timeHeader">Time Left : </span>
      <div style={{ display: "flex" }}>
        {showTimer.split(" : ").map((part, index) => (
          <React.Fragment key={index}>
            <div className="timerun">{part}</div>
            {index < 2 && (
              <span style={{ margin: "0 5px" }}>:</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ state });
export default connect(mapStateToProps)(IitSectionTimer2);
